import type { RouteObject } from 'react-router';
import { recordTabRoutes } from '../../shared/components/record-tab-routes';
import { DriversPage } from './pages/DriversPage';
import { DriverDetailPage } from './pages/DriverDetailPage';
import { DRIVER_TABS } from './drivers.paths';

export const DRIVER_ROUTES: RouteObject[] = [
  { path: 'drivers', element: <DriversPage /> },
  ...recordTabRoutes('drivers/:id', DRIVER_TABS, (tab) => <DriverDetailPage tab={tab} />),
];
